module.exports = __webpack_public_path__ + "static/media/phone.b6e33442.svg";